import { atom } from 'recoil';

export const generalChatInputState = atom({
  key: 'generalChatInputState',
  default: null
});

export const generalChatIdState = atom({
  key: 'intelligenceGeneralChatIdState',
  default: null
});

export const generalChatMessageIdState = atom({
  key: 'intelligenceGeneralChatMessageIdState',
  default: null
});

export const generalChatPromptListState = atom({
  key: 'generalChatPromptListState',
  default: []
});

export const generalChatActivePromptConversationsState = atom({
  key: 'generalChatActivePromptConversationsState',
  default: []
});

export const generalChatLoading = atom({
  key: 'generalChatLoading',
  default: false
});

export const generalChatGenerating = atom({
  key: 'generalChatGenerating',
  default: false
});

export const generalChatActivePromptIdState = atom({
  key: 'generalChatActivePromptIdState',
  default: null
});
